var enterPressed = true;

class AutoCompleteField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: [],
            value: props.value,
            cursor: 0
        }

        this.bodyClick = this.bodyClick.bind(this);
    }

    componentWillReceiveProps(Props) {
        if (Props.values != null && (document.activeElement.id == Props.id)) {
            this.generateList(Props.values, Props.value);
        }
    }

    componentDidMount() {
        document.body.addEventListener('click', this.bodyClick);
        document.body.addEventListener('mousedown', this.mouseDown);
    }

    componentWillUnmount() {
        document.body.removeEventListener('mousedown', this.mouseDown);
        document.body.removeEventListener('click', this.bodyClick);
    }

    bodyClick(event) {
        const domNode = ReactDOM.findDOMNode(this);

        if (!domNode || !domNode.contains(event.target)) {
            var value = this.props.value;
            if (this.props.FromList) {
                //if we have any values provided
                if (this.props.values != "") {
                    var inList = this.props.values.filter(function (source) { return source.toLowerCase() == value.toLowerCase(); });
                    if (inList.length == 0)
                        value = "";
                    //this is a dynamic autocmplete, so build out a search for it
                }
                else {
                    var oDynamicAutoComplete = this.props.oDynamicAutoComplete
                    if (oDynamicAutoComplete != null) {
                        var spec = this.props.spec;
                        for (var b = 0; b < oDynamicAutoComplete.length; b++) {
                            if (oDynamicAutoComplete[b].DefinedSpecID == spec.DefinedSpecID) {
                                if (value.length >= 2) {
                                    oDynamicAutoComplete[b].TypedText = value;

                                    var xhr1 = new XMLHttpRequest();
                                    xhr1.onload = function () {
                                        var response = JSON.parse(xhr1.response);
                                        var values = response.oDynamicAutoComplete.Source
                                        //filter out the dynamic results
                                        if (values != null) {
                                            var inList = values.filter(function (source) { return source.toLowerCase() == value.toLowerCase(); });
                                            if (inList.length == 0)
                                                value = "";
                                        }
                                    }.bind(this);

                                    xhr1.open("POST", '/listinginput/base/DynamicAutoComplete', false);
                                    xhr1.setRequestHeader("Content-type", "application/json");
                                    xhr1.send(JSON.stringify(oDynamicAutoComplete[b]));
                                }
                                else {
                                    value = "";
                                }
                            }
                        }
                    }
                }
            }

            //if we didn't get any results back, fire the onFieldChanged event
            if (value != this.props.value)
                this.props.onFieldChanged(value);

            this.setState({
                options: [],
                cursor: 0
            });
        }
    }

    //Will filter out values based off of the input text
    autocomplete(values, inputText) {
        //If we want these sorted
        if (this.props.Sort) {
            //filter out values we can't find in the list (anywhere)
            var filter = values.filter(function (str) {
                return str.toLowerCase().indexOf(inputText.toLowerCase()) > -1;
            });
            //sort the list according to where in the option the input text occurs (start prioritized)
            filter = filter.sort(function (a, b) {
                var indexa = a.toLowerCase().indexOf(inputText.toLowerCase())
                var indexb = b.toLowerCase().indexOf(inputText.toLowerCase())
                return indexa - indexb;
            });
            return filter;
        }
        return values;
    }

    //changes when the text input changes
    inputChange(event) {
        var inputText = event.target.value;
        this.setState({
            ...this.state,
            value: inputText
        });

        //FALSE is only for listingdetail
        this.props.onFieldChanged(inputText, false);
    }

    generateList(values, inputText) {
        //list of options to show
        var show = [];
        var options = [];

        //if we have values and the enter key wans't pressed
        if (values != null && !enterPressed) {
            //if we have any typed text
            if (inputText.length > 0) {
                show = this.autocomplete(values, inputText);

                //if we have more than 1 option, and the first option isn't the input text
                if (show.length != 1 || show[0] != inputText) {
                    var iCursor = this.state.cursor;
                    if (iCursor == null || iCursor < 0)
                        iCursor = 0;
                    if (show.length < iCursor + 1)
                        iCursor = show.length - 1;

                    //for each option we're planning on showing
                    for (let i = 0; i < show.length; i++) {
                        options.push(<li className={iCursor === i ? 'hovered' : null} onMouseOver={(e) => { this.handleMouseOver(e); }} key={i} datavalue={show[i]}>{show[i]}</li>);
                    }
                }
            }
        }

        //update the options object with the latest HTML
        this.setState({
            options: options,
            cursor: iCursor
        });
    }

    //if an option in the list has been chosen
    listClick(event) {
        enterPressed = true;
        this.props.onFieldChanged(event.target.getAttribute("datavalue"), true);

        this.setState({
            options: [],
            cursor: 0,
        });

        if (this.props.id != "ModelSelected") {
            this.OnBlur(event);
        }
    }

    mouseDown(event) {
        if (event.target.tagName == "LI") {
            event.preventDefault();
        }
    }

    OnBlur(event) {
        if (this.props.UseNewManuBlurEvent) {
            var focusedElem = document.querySelector("li.hovered");
            if (focusedElem) {
                this.props.onBlur(event, focusedElem.innerText);
            }
            else {
                this.props.onBlur(event, null);
            }
        }
        else if (this.props.onBlur != null) {
            this.props.onBlur(event, event.target.getAttribute('datavalue'));
        }
    }

    //check if the autocomplete is in view
    checkInView(elem, container) {

        //Get container properties
        let cTop = container.scrollTop;
        let cBottom = cTop + container.clientHeight;

        //Get element properties
        let eTop = elem.offsetTop;
        let eBottom = eTop + elem.clientHeight;

        //Check if in view    
        let isTotal = (eTop >= cTop && eBottom <= cBottom);

        //Return outcome
        return isTotal;
    }

    handleMouseOver(e) {
        var iCursor = 0

        //figure out which option is being hovered over
        for (var i = 0; i < this.state.options.length; i++) {
            if (e.target.innerText == this.state.options[i].props.datavalue)
                iCursor = i;
        }

        var show = [];
        var options = [];

        show = this.autocomplete(this.props.values, this.props.value);

        for (let i = 0; i < show.length; i++) {
            options.push(<li className={iCursor === i ? 'hovered' : null} onMouseOver={(e) => { this.handleMouseOver(e); }} key={i} datavalue={show[i]}>{show[i]}</li>);
        }

        this.setState({
            cursor: iCursor,
            options: options
        });
    }

    handleKeyDown(e) {
        enterPressed = false;
        // arrow up/down button should select next/previous list element
        if (e.keyCode === 38 && this.state.options.length != 0) {
            e.preventDefault();

            var iCursor = this.state.cursor;
            if (this.state.cursor == 0)
                iCursor = this.state.options.length - 1;
            else
                iCursor--;

            var show = [];
            var options = [];

            show = this.autocomplete(this.props.values, this.props.value);

            for (let i = 0; i < show.length; i++) {
                options.push(<li className={iCursor === i ? 'hovered' : null} onMouseOver={(e) => { this.handleMouseOver(e); }} key={i} datavalue={show[i]}>{show[i]}</li>);
            }

            //set the state
            this.setState({
                cursor: iCursor,
                options: options
            }, () => {
                //get the hovered element and scroll to it if not in view
                var element = document.querySelector('li.hovered');
                var container = element.parentNode;
                var inView = this.checkInView(element, container);
                if (!inView) {
                    container.scrollTop = element.offsetTop - 10;
                }
            });

            //if the user presses the down arrow and we have options
        }
        else if (e.keyCode === 40 && this.state.options.length != 0) {
            e.preventDefault();

            var iCursor = this.state.cursor;
            //if we're at the end of the list, go back to the first option. Otherwise move the cursor to the next
            if (this.state.cursor == this.state.options.length - 1)
                iCursor = 0;
            else
                iCursor++;

            var show = [];
            var options = [];

            show = this.autocomplete(this.props.values, this.props.value);

            for (let i = 0; i < show.length; i++) {
                options.push(<li className={iCursor === i ? 'hovered' : null} onMouseOver={(e) => { this.handleMouseOver(e); }} onKeyDown={(e) => { this.handleKeyDown(e); }} key={i} datavalue={show[i]}>{show[i]}</li>);
            }

            this.setState({
                cursor: iCursor,
                options: options
            }, () => {
                //scroll to hovered item if not in view
                var element = document.querySelector('li.hovered');
                var container = element.parentNode;
                var inView = this.checkInView(element, container);
                if (!inView) {
                    container.scrollTop = element.offsetTop - container.clientHeight + element.clientHeight;
                }
            });
        }
        else if (e.keyCode === 13 || e.keyCode === 9) {   //TAB or ENTER
            if (e.keyCode === 13)
                e.preventDefault();

            enterPressed = true
            var element = document.querySelector('li.hovered');

            this.setState({
                options: [],
                cursor: 0
            });
            //we should fire the blur event here since we're losing focus on the input
            if (this.props.UseNewManuBlurEvent) {
                if (element) {
                    this.props.onBlur(e, element.innerText);
                }
            }
            else if (this.props.onFieldChanged) {
                if (element) {
                    this.setState({
                        ...this.state,
                        value: element.innerText
                    });
                }
                if (element) {
                    this.props.onFieldChanged(element.innerText, true);
                }
            }
        }
    }

    render() {

        var style = {};

        if (this.props.disabled) {
            style.background = '#EBEBE4';
        }

        var styleUL = {};
        styleUL.zIndex = 1
        if (this.state.options.length < 1)
            styleUL.visibility = "hidden";

        //build the className for the input element
        var inputClassName = this.props.error ? "inputError " : "";
        inputClassName = inputClassName + (this.props.className || "");

        if (this.props.highlight && this.props.highlight != "")
            inputClassName = inputClassName + " " + this.props.highlight;

        if (this.props.feRequired)
            inputClassName = inputClassName + " fe-required-field";

        //build the id for the input element
        var inputID = this.props.id;

        var label = "";
        if (!this.props.hasLabel) {
            label =
                this.props.isRequired ?
                    <label htmlFor={inputID}> <span className="required-red"> *</span>{this.props.label || this.props.placeholder} {"\n"}</label>
                    :
                    <label htmlFor={inputID}>{this.props.label || this.props.placeholder} {"\n"}</label>
        }

        return (
            <div className="autocomplete-container">
                {label}
                <input
                    style={style}
                    onKeyDown={(e) => { this.handleKeyDown(e); }}
                    autoComplete="off"
                    disabled={this.props.disabled ? true : false}
                    type="text"
                    placeholder={this.props.placeholder}
                    value={this.props.value || ''}
                    onChange={(e) => { this.inputChange(e); }}
                    onBlur={(e) => { this.OnBlur(e) }}
                    className={inputClassName}
                    id={inputID}
                />
                <ul className="autocomplete-results" style={styleUL} onClick={(e) => { this.listClick(e); }}>
                    {this.state.options}
                </ul>
                <p style={{ margin: '0' }} className="validationError">
                    <span dangerouslySetInnerHTML={{ __html: this.props.errorText }}></span>
                </p>
            </div>
        );
    }
}

export default AutoCompleteField;
global.AutoCompleteField = AutoCompleteField;